import React, { useEffect, useState } from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { pageTitle } from '../../helper';
import Div from '../Div';
import Spacing from '../Spacing';
import './whitepaper.css';

export default function WhitePaper() {
  pageTitle('Whitepaper');

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
  });

  // Store client-side validation errors per field
  const [errors, setErrors] = useState({});

  // A separate error/success message for server-related failures
  const [serverError, setServerError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [downloadLink, setDownloadLink] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // -------------------------
  // Validation Function
  // -------------------------
  const validate = () => {
    const newErrors = {};

    // First Name
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First Name is required';
    }

    // Last Name
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last Name is required';
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Mobile - basic check
    const numericPhone = formData.mobile.replace(/\D/g, '');
    if (!numericPhone) {
      newErrors.mobile = 'Mobile number is required';
    } else if (numericPhone.length < 8) {
      newErrors.mobile = 'Mobile number is too short';
    }

    return newErrors;
  };

  // -------------------------
  // Event Handlers
  // -------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear the field-specific error
    setErrors((prev) => ({ ...prev, [name]: '' }));
    // Clear any server error if user is modifying the form again
    setServerError('');
  };

  const handlePhoneChange = (value) => {
    setFormData((prev) => ({ ...prev, mobile: value }));
    setErrors((prev) => ({ ...prev, mobile: '' }));
    setServerError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate client side
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Clear old messages before fetch
    setServerError('');

    // Submit
    try {
      const response = await fetch('/api/whitepaper', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        // success
        setDownloadLink(result.downloadUrl);
        setSubmitted(true);
      } else {
        // server responded with an error
        setServerError(result.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setServerError('There was an error submitting the form. Please try again later.');
    }
  };

  // -------------------------
  // Render
  // -------------------------
  return (
    <>
      <Spacing lg="145" md="80" />
      {!submitted ? (
        <Div className="container">
          <div className="whitepaper-container">
            <div className="imagecontainer">
              <img src="/images/whitepaper.jpeg" alt="whitepaper" />
            </div>
            <form onSubmit={handleSubmit} className="whitepaperform">
              {/* Show a server error if any */}
              {serverError && (
                <div
                  style={{
                    marginBottom: '20px',
                    padding: '10px',
                    color: '#b10000',
                    backgroundColor: '#ffe5e5',
                    border: '1px solid #b10000',
                  }}
                >
                  {serverError}
                </div>
              )}

              {/* First Name */}
              <Div>
                <label className="cs-secondary_color">First Name*</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="cs-form_field"
                />
                {errors.firstName && (
                  <p style={{ color: 'red' }}>{errors.firstName}</p>
                )}
                <Spacing lg="20" md="20" />
              </Div>

              {/* Last Name */}
              <Div>
                <label className="cs-secondary_color">Last Name*</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="cs-form_field"
                />
                {errors.lastName && (
                  <p style={{ color: 'red' }}>{errors.lastName}</p>
                )}
                <Spacing lg="20" md="20" />
              </Div>

              {/* Email */}
              <Div>
                <label className="cs-secondary_color">Email*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="cs-form_field"
                />
                {errors.email && (
                  <p style={{ color: 'red' }}>{errors.email}</p>
                )}
                <Spacing lg="20" md="20" />
              </Div>

              {/* Mobile (ReactPhoneInput) */}
              <Div>
                <label className="cs-secondary_color">Mobile*</label>
                <ReactPhoneInput
                  country=""
                  value={formData.mobile}
                  onChange={handlePhoneChange}
                  placeholder="Enter your mobile number"
                  inputStyle={{
                    width: '100%',
                    height: '40px',
                  }}
                />
                {errors.mobile && (
                  <p style={{ color: 'red' }}>{errors.mobile}</p>
                )}
                <Spacing lg="20" md="20" />
              </Div>

              <Spacing lg="20" md="20" />
              <Div>
                <button type="submit" className="cs-btn cs-style1">
                  <span>Submit</span>
                </button>
              </Div>
            </form>
          </div>
        </Div>
      ) : (
        <div className="thankyoucontainer">
          <h2 style={{ color: '#FF4A17' }}>Thank you for your submission</h2>
          <a href={downloadLink} target="_blank" rel="noopener noreferrer">
            Your Download Link
          </a>
        </div>
      )}
    </>
  );
}
